import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { SubdistrictDetailForm } from "@/features/subdistrict/SubdistrictDetailForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function SubdistrictDetail() {
  const { id } = useParams();
  if (id === undefined) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/district",
            label: "District (Kec)",
          },
          {
            label: "Detail",
          },
        ]}
      />
      <H2>District (Kec) Detail</H2>
      <SubdistrictDetailForm id={id} />
    </>
  );
}
